import { Box } from '@mantine/core';
import cx from 'clsx';

import classes from './modal-theme.module.css';

import type { BoxProps } from '@mantine/core';
import type { ReactNode } from 'react';

type ModalFooterProps = BoxProps & { children?: ReactNode };

export const ModalFooter = ({ children, className, ...props }: ModalFooterProps) => (
  <Box className={cx(classes.footer, className)} {...props}>
    {children}
  </Box>
);
